/* eslint-disable  no-irregular-whitespace */
import { ArticleHeading5, ArticleParagraph2, Faq16, Tooltip } from '@cian/ui-kit';
import * as React from 'react';

import * as styles from './styles.css';

export interface ICianEstimationTooltipProps {
  onOpen?(): void;
  estimationRange: React.ReactChild;
  tooltipText: string;
  infoUrl?: string | null;
}

export const CianEstimationTooltip: React.FC<ICianEstimationTooltipProps> = props => {
  const { estimationRange, infoUrl, onOpen, tooltipText } = props;

  return (
    <Tooltip
      title={
        <div className={styles['container']} data-testid="valuation_estimation_faq">
          <ArticleHeading5>Об оценке Циан</ArticleHeading5>
          <div className={styles['range']}>
            <ArticleParagraph2>Диапазон оценки: {estimationRange}</ArticleParagraph2>
          </div>
          <div className={styles['description']}>
            <ArticleParagraph2>{tooltipText}</ArticleParagraph2>
          </div>
          {infoUrl && infoUrl !== 'none' && (
            <div className={styles['link_wrapper']}>
              <a className={styles['link']} href={infoUrl} target="_blank" rel="noreferrer">
                Подробнее об оценке
              </a>
            </div>
          )}
        </div>
      }
      theme="white"
      placement="right-start"
      onOpen={onOpen}
    >
      <div className={styles['faq_icon']} data-testid="valuation_estimation_faq_icon">
        <Faq16 display="block" color="primary_100" />
      </div>
    </Tooltip>
  );
};

CianEstimationTooltip.displayName = 'CianEstimationTooltip';
